import { track } from './events'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/** Collapses high-cardinality paths to a route pattern (no raw ids). */
const toRoutePattern = (pathname: string): string => {
  if (/^\/conversations\/[^/]+$/.test(pathname)) return '/conversations/:id'
  return pathname
}

/** Fires portalPageVisited on every route change. Mounted once at the app root. */
export const usePageViewTracking = (): void => {
  const { pathname } = useLocation()
  useEffect(() => {
    track.portalPageVisited(toRoutePattern(pathname))
  }, [pathname])
}
